<div id="content-wrapper" class="d-flex flex-column ml-0" *ngIf="true">
  <!-- Main Content -->
  <div id="content">
    <div class="container-fluid">
      <div class="row logo">
        <div class="col-12 row no-gutters justify-content-center">
          <h1 class="d-flex justify-content-center" style="flex-direction: column; align-items: center">
            <img src="/assets/doctors-next/Logo.png" alt="Doctors Next" />
          </h1>
        </div>
      </div>

      <!--  -->
      <div *ngIf="!isRegistarble" class="row no-gutters mx-auto error-message mt-5">
        <div class="col-md-12 col-12">
          <div class="alert alert-danger" role="alert">
            <ul class="m-0">
              <li *ngFor="let message of errorMessages.signup | keyvalue">
                {{ message.value }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row justify-content-center mb-3">
        <div id="main" class="col-md-12 text-center">

          <div class="row">
            <div class="col-md-12  text-center">
              <h2 class="caption mt-4">登録内容確認</h2>
            </div>
          </div>
          <!-- 姓名 -->
          <div class="row">
            <div class="col-6 text-left"><label class="col-form-label text-caption">姓</label>
            </div>
            <div class="col-6 text-left"><label class="col-form-label text-caption">名</label>
            </div>
            <div class="col-6">
              <div class="form-group">
                <input type="text" class="form-control" [value]="registerStateService.base.familyName" disabled />
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <input type="text" class="form-control" [value]="registerStateService.base.givenName" disabled />
              </div>
            </div>
          </div>

          <div class="row" *ngFor="let row of rows">
            <div class="col-md-6 text-left"><label class="col-form-label text-caption">{{row.label}}</label>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <input type="text" class="form-control" [value]="row.value" disabled />
              </div>
            </div>
          </div>
          <!--  -->


          <!-- ボタン群 -->
          <div class="row">
            <div class="col-md-12">
              <div class="row justify-content-center">
                <app-doctors-next-button (click)="apply();" label="確定する"></app-doctors-next-button>
              </div>
              <div class="row justify-content-center mt-4">
                <button id="cancel_button" (click)="cancel();">戻る</button>
              </div>
            </div>
          </div>
        </div>

        <!--  -->
      </div>
    </div>
  </div>

</div>